module.exports = __webpack_public_path__ + "static/media/samfunnsdialog_ios_add_to_homescreen.a2c57bae.png";